import passiveEventsSupported from './passiveEventsSupported';

export default (target, eventName, handler) =>
  target.addEventListener(
    eventName,
    handler,
    passiveEventsSupported ? { passive: true } : false,
  );
